import { iosVhFix } from './utils/ios-vh-fix.js'
import { initModals } from './modules/modals/init-modals.js'
import { swiper } from './modules/swiper.js'
import { forms } from './modules/forms.js'
import { aosAnimation } from './modules/aosAnimation.js'
import { initHeaderScroll } from './modules/init-header-scroll.js'
import { initMenuOverlay } from '../templates/components/menu-btn/init-menu-overlay.js'
import { initHeroStudioScroll } from './modules/init-hero-studio-scroll.js'
import { initHeroMacbookSwiper } from './modules/init-hero-macbook-swiper.js'
import { initHeroItemsSwiper } from './modules/init-hero-items-swiper.js'
import { initSiteFormatsSwiper } from './modules/init-site-formats-swiper.js'
import { initMasanyaLottie } from './modules/init-masanya-lottie.js'
import { initPreloader } from './modules/init-preloader.js'
import { initSiteTaskDashboard } from './modules/init-site-task-dashboard.js'
import { initSiteTaskMarquee } from './modules/init-site-task-marquee.js'
import { initSitePrinciples } from './modules/init-site-principles.js'
import { initBitrixCasesSwiper } from './modules/init-bitrix-cases-swiper.js'
import { initFooterMenu } from './modules/init-footer-menu.js'
import initReadySiteCalc from './modules/init-ready-site-calc.js'

// ---------------------------------
window.addEventListener('DOMContentLoaded', () => {

  // Utils
  // ---------------------------------
  initPreloader()
  iosVhFix()
  initHeaderScroll()
  initMenuOverlay()
  initHeroMacbookSwiper()
  initHeroStudioScroll()
  initHeroItemsSwiper()
  initMasanyaLottie()
  initSiteFormatsSwiper()
  initSiteTaskDashboard()
  initSiteTaskMarquee()
  initSitePrinciples()
  initBitrixCasesSwiper()
  initFooterMenu()
  initReadySiteCalc()

  // Modules
  // ---------------------------------
  initModals()
  swiper()
  aosAnimation()
  forms()

  // в load следует добавить скрипты, не участвующие в работе первого экрана
  window.addEventListener('load', () => {

  })
})

// ---------------------------------

// привязывайте js не на классы, а на дата атрибуты (data-validate)

// вместо модификаторов .block--active используем утилитарные классы
// .is-active || .is-open || .is-invalid и прочие (обязателен нейминг в два
// слова) .select.select--opened ❌ ---> [data-select].is-open ✅

// выносим все в дата атрибуты
// url до иконок пинов карты, настройки автопрокрутки слайдера, url к json и
// т.д.

// для адаптивного JS используется matchMedia и addListener
// const breakpoint = window.matchMedia(`(min-width:1024px)`);
// const breakpointChecker = () => {
//   if (breakpoint.matches) {
//   } else {
//   }
// };
// breakpoint.addListener(breakpointChecker);
// breakpointChecker();

// используйте .closest(el)
